import onResize from '../utils/onResize';

let prevScrollPosition = window.scrollY;

function createHeadRoom(header) {
    const screenWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if (screenWidth > 1137) {
        const currentScrollPosition = window.scrollY;
        // const collapseMenuShow = document.querySelector('.collapsible-show');
        if (currentScrollPosition >= 110) {
            if (prevScrollPosition > currentScrollPosition) {
                requestAnimationFrame(() => header.style.transform = 'translateY(0px)');
            } else {
                requestAnimationFrame(() => header.style.transform = 'translateY(-110px)');
            }
        }
        prevScrollPosition = currentScrollPosition;

        // At the bottom of page -> Show nav menu
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
            requestAnimationFrame(() => header.style.transform = 'translateY(0px)');
        }
    }
}

export default function init(el) {
    window.addEventListener('scroll', () => createHeadRoom(el));
    onResize(() => createHeadRoom(el));
}
